import { CustomerDeeplinks } from '@owner/deeplinks'

import { analytics } from '@/plugins/analytics'

declare global {
  interface Document {
    prerendering?: boolean
  }
}

/**
 * Operator web-fallback first-party click capture. When an operator lands on a
 * dashboard page that is a `tracked` customer deeplink AND carries its stable-key
 * marker, capture a 'Deeplink Clicked' PostHog event. Registry-gated — dormant
 * until a customer destination opts in, so it needs no per-path logic.
 * Best-effort: never throws.
 * @param currentUrl
 */
export function recordDeeplinkClick(currentUrl: string): void {
  if (document.prerendering) {
    // A prerendered page hasn't been seen by the visitor yet; count the click on activation instead.
    document.addEventListener(
      'prerenderingchange',
      () => recordDeeplinkClick(currentUrl),
      { once: true }
    )
    return
  }

  let resolved
  try {
    resolved = new CustomerDeeplinks(
      new URL(currentUrl).origin
    ).resolveTrackedClick(currentUrl)
  } catch {
    return
  }
  if (!resolved?.stableKey) return

  const brandId = (resolved.params as { brandId?: string }).brandId
  if (!brandId) return

  analytics.track('Deeplink Clicked', {
    brandId,
    deeplinkStableId: resolved.stableKey,
    linkKey: String(resolved.key),
    source: 'web',
    surface: 'operator',
  })
}
